/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const astar_chain_about = () => `Astar Network is a layer-1 blockchain built on Substrate that supports both EVM and WebAssembly smart contracts. It is designed to be a smart contract hub for the Polkadot ecosystem, providing developers with a one-stop shop for building and deploying dApps.`
